// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__JaqDL","close_btn":"Cart_close_btn__x8soO","checkoutBtn":"Cart_checkoutBtn__zstL2"};